import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form} from "react-bootstrap";
import InputMask from "react-input-mask";
import usStateOptions from "../../utils/usStateOptions";
import Spinner from 'react-bootstrap/Spinner';

import getPracticeOnboardingStages from "../../utils/practiceOnboardingStages";

const { REACT_APP_BACKEND_URL } = process.env;


const PracticeOnboardingDemographics = ({stage, token, data}) => {
  let usStateOptionList = usStateOptions.map((state) => {
    var label = state.label === "" ? "State..." : state.label;
    return (
      <option value={state.value} key={state.value}>{label}</option>
    )
  }, this);

  
  let practiceOnboardingStages = getPracticeOnboardingStages();

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        phone: data.phone == null ? "" : data.phone,
        fax: data.fax == null ? "" : data.fax,
        email: data.email == null ? "" : data.email,
        tin: data.tin == null ? "" : data.tin,
        officeManager: data.officeManager == null ? "" : data.officeManager,
        officeManagerPhone: data.officeManagerPhone == null ? "" : data.officeManagerPhone,
        officeManagerEmail: data.officeManagerEmail == null ? "" : data.officeManagerEmail,
        npi: data.npi == null ? "" : data.npi,
        address1: data.address1 == null ? "" : data.address1,
        address2: data.address2 == null ? "" : data.address2,
        city: data.city == null ? "" : data.city,
        state: data.state == null ? "" : data.state,
        zip: data.zip == null ? "" : data.zip,
        mailingAddress1: data.mailingAddress1 == null ? "" : data.mailingAddress1,
        mailingAddress2: data.mailingAddress2 == null ? "" : data.mailingAddress2,
        mailingCity: data.mailingCity == null ? "" : data.mailingCity,
        mailingState: data.mailingState == null ? "" : data.mailingState,
        mailingZip: data.mailingZip == null ? "" : data.mailingZip,
        remitAddress1: data.remitAddress1 == null ? "" : data.remitAddress1,
        remitAddress2: data.remitAddress2 == null ? "" : data.remitAddress2,
        remitCity: data.remitCity == null ? "" : data.remitCity,
        remitState: data.remitState == null ? "" : data.remitState,
        remitZip: data.remitZip == null ? "" : data.remitZip,
        officeHours: data.officeHours == null ? "" : data.officeHours,
        groupMedicare: data.groupMedicare == null ? "" : data.groupMedicare,
        groupMedicaid: data.groupMedicaid == null ? "" : data.groupMedicaid,        
      }}
      validationSchema={Yup.object().shape({
        phone: Yup.string().required('Phone is required')
          .transform(value => value.replace(/[^\d]/g, ''))
          .matches(
            /^\d{10}$/,
            "Must be valid phone number"
          ),
        fax: Yup.string().required('Fax is required')
          .transform(value => value.replace(/[^\d]/g, ''))
          .matches(
            /^\d{10}$/,
            "Must be valid phone number"
          ),
        email: Yup.string().email("Must be a valid email").max(255)
          .required("Email is required"),
        tin: Yup.string().max(255).required("TIN is required"),
        officeManager: Yup.string().max(255).required("Office manager is required"),
        officeManagerPhone: Yup.string().required('Office manager phone is required')
          .transform(value => value.replace(/[^\d]/g, ''))
          .matches(
            /^\d{10}$/,
            "Must be valid phone number"
          ),
        officeManagerEmail: Yup.string().email("Must be a valid email").max(255)
          .required("Office manager email is required"),
        address1: Yup.string().required("Address is required").max(255),
        address2: Yup.string().max(255),
        city: Yup.string().required("Address is required").max(255),
        state: Yup.string().required("Address is required").max(255),
        zip: Yup.string().required("Address is required")
          .matches(/^\d{5}$/, "Please enter valid zip code"),
        mailingAddress1: Yup.string().required("Mailing address is required").max(255),
        mailingAddress2: Yup.string().max(255),
        mailingCity: Yup.string().required("Mailing address is required").max(255),
        mailingState: Yup.string().required("Mailing address is required").max(255),
        mailingZip: Yup.string().required("Mailing address is required")
          .matches(/^\d{5}$/, "Please enter valid zip code"),
        remitAddress1: Yup.string().required("Remit address is required").max(255),
        remitAddress2: Yup.string().max(255),
        remitCity: Yup.string().required("Remit address is required").max(255),
        remitState: Yup.string().required("Remit address is required").max(255),
        remitZip: Yup.string().required("Remit address is required")
          .matches(/^\d{5}$/, "Please enter valid zip code"),
        officeHours: Yup.string().required("Office hours are required").max(255),
        groupMedicare: Yup.string().max(255),
        groupMedicaid: Yup.string().max(255)
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();
          formData.append("data", new Blob([JSON.stringify(
            {
              phone: values.phone,
              fax: values.fax,
              email: values.email,
              tin: values.tin,
              officeManager: values.officeManager,
              officeManagerPhone: values.officeManagerPhone,
              officeManagerEmail: values.officeManagerEmail,
              npi: values.npi,
              address1: values.address1,
              address2: values.address2,
              city: values.city,
              state: values.state,
              zip: values.zip,
              mailingAddress1: values.mailingAddress1,
              mailingAddress2: values.mailingAddress2,
              mailingCity: values.mailingCity,
              mailingState: values.mailingState,
              mailingZip: values.mailingZip,
              remitAddress1: values.remitAddress1,
              remitAddress2: values.remitAddress2,
              remitCity: values.remitCity,
              remitState: values.remitState,
              remitZip: values.remitZip,
              officeHours: values.officeHours,
              groupMedicare: values.groupMedicare,
              groupMedicaid: values.groupMedicaid
            })], {
              type: "application/json"
          }));

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "practice-onboarding/" + stage + "/" + token, requestMetadata);

          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/practice-onboarding/" + practiceOnboardingStages[practiceOnboardingStages.indexOf(stage) + 1]  + "/" + token
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        getFieldProps,
        isSubmitting,
        status,
        touched,
        values,
      }) => 

      (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Phone*</Form.Label>
            <InputMask
              type="tel"
              mask='(999) 999-9999'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.phone}>
              {(inputProps) => <Form.Control
                name="phone"
                {...inputProps} 
                isInvalid={Boolean(touched.phone && errors.phone)}
              />}
            </InputMask>
            {!!touched.phone && (
              <Form.Control.Feedback type="invalid">
                {errors.phone}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Fax*</Form.Label>
            <InputMask
              type="tel"
              mask='(999) 999-9999'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.fax}>
              {(inputProps) => <Form.Control
                name="fax"
                {...inputProps} 
                isInvalid={Boolean(touched.fax && errors.fax)}
              />}
            </InputMask>
            {!!touched.fax && (
              <Form.Control.Feedback type="invalid">
                {errors.fax}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Email*</Form.Label>
            <Form.Control
              name="email"
              // AUTO focus breaks the submit touching the fields - see bug report https://github.com/jaredpalmer/formik/issues/1783
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.email}
              isInvalid={Boolean(touched.email && errors.email)}
              />
            {!!touched.email && (
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Tax ID*</Form.Label>
            <Form.Control
              name="tin"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.tin}
              isInvalid={Boolean(touched.tin && errors.tin)}
            />
            {!!touched.tin && (
              <Form.Control.Feedback type="invalid">
                {errors.tin}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Office Manager Name*</Form.Label>
            <Form.Control
              name="officeManager"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.officeManager}
              isInvalid={Boolean(touched.officeManager && errors.officeManager)}
            />
            {!!touched.officeManager && (
              <Form.Control.Feedback type="invalid">
                {errors.officeManager}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Office Manager Phone*</Form.Label>
            <InputMask
              type="tel"
              mask='(999) 999-9999'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.officeManagerPhone}>
              {(inputProps) => <Form.Control
                name="officeManagerPhone"
                {...inputProps} 
                isInvalid={Boolean(touched.officeManagerPhone && errors.officeManagerPhone)}
              />}
            </InputMask>
            {!!touched.officeManagerPhone && (
              <Form.Control.Feedback type="invalid">
                {errors.officeManagerPhone}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Office Manager Email*</Form.Label>
            <Form.Control
              name="officeManagerEmail"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.officeManagerEmail}
              isInvalid={Boolean(touched.officeManagerEmail && errors.officeManagerEmail)}
              />
            {!!touched.officeManagerEmail && (
              <Form.Control.Feedback type="invalid">
                {errors.officeManagerEmail}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Practice NPI*</Form.Label>
            <InputMask
              type="tel"
              mask='9999999999'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.npi}>
              {(inputProps) => <Form.Control
                name="npi"
                {...inputProps} 
                isInvalid={Boolean(touched.npi && errors.npi)}
              />}
            </InputMask>
            {!!touched.npi && (
              <Form.Control.Feedback type="invalid">
                {errors.npi}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Address*</Form.Label>
            <br />
            <Form.Control
              name="address1"
              placeholder="Street 1"
              style={{ width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.address1}
              isInvalid={Boolean(touched.address1 && errors.address1)}
            />
            <Form.Control
              name="address2"
              placeholder="Street 2"
              style={{ width: "48%", display: "inline"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.address2}
              isInvalid={Boolean(touched.address2 && errors.address2)}
            />
            <Form.Control
              name="city"
              placeholder="City"
              style={{ marginTop: "30px", width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.city}
              isInvalid={Boolean(touched.city && errors.city)}
            />
            <Form.Select
              name="state"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.state} 
              isInvalid={Boolean(touched.state && errors.state)}
              style={{marginTop: "30px", width: "20%", marginRight: "4%", display: "inline"}}>
                {usStateOptionList}
            </Form.Select>
            <InputMask
              style={{marginTop: "30px", width: "24%", display: "inline"}}
              type="tel"
              mask='99999'
              placeholder="Zip"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.zip}>
              {(inputProps) => <Form.Control
                name="zip"
                {...inputProps} 
                isInvalid={Boolean(touched.zip && errors.zip)}
              />}
            </InputMask>
            {(!!touched.address1 || !!touched.address2 || !!touched.city || !!touched.state || !!touched.zip) && (
              <Form.Control.Feedback type="invalid">
                {errors.address1 || errors.address2 || errors.city || errors.state || errors.zip}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Mailing Address*</Form.Label>
            <br />
            <Form.Control
              name="mailingAddress1"
              placeholder="Street 1"
              style={{ width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mailingAddress1}
              isInvalid={Boolean(touched.mailingAddress1 && errors.mailingAddress1)}
            />
            <Form.Control
              name="mailingAddress2"
              placeholder="Street 2"
              style={{ width: "48%", display: "inline"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mailingAddress2}
              isInvalid={Boolean(touched.mailingAddress2 && errors.mailingAddress2)}
            />
            <Form.Control
              name="mailingCity"
              placeholder="City"
              style={{ marginTop: "30px", width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mailingCity}
              isInvalid={Boolean(touched.mailingCity && errors.mailingCity)}
            />
            <Form.Select
              name="mailingState"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mailingState} 
              isInvalid={Boolean(touched.mailingState && errors.mailingState)}
              style={{marginTop: "30px", width: "20%", marginRight: "4%", display: "inline"}}>
                {usStateOptionList}
            </Form.Select>
            <InputMask
              style={{marginTop: "30px", width: "24%", display: "inline"}}
              type="tel"
              mask='99999'
              placeholder="Zip"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.mailingZip}>
              {(inputProps) => <Form.Control
                name="mailingZip"
                {...inputProps} 
                isInvalid={Boolean(touched.mailingZip && errors.mailingZip)}
              />}
            </InputMask>
            {(!!touched.mailingAddress1 || !!touched.mailingAddress2 || !!touched.mailingCity || !!touched.mailingState || !!touched.mailingZip) && (
              <Form.Control.Feedback type="invalid">
                {errors.mailingAddress1 || errors.mailingAddress2 || errors.mailingCity || errors.mailingState || errors.mailingZip}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Remit Address*</Form.Label>
            <br />
            <Form.Control
              name="remitAddress1"
              placeholder="Street 1"
              style={{ width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.remitAddress1}
              isInvalid={Boolean(touched.remitAddress1 && errors.remitAddress1)}
            />
            <Form.Control
              name="remitAddress2"
              placeholder="Street 2"
              style={{ width: "48%", display: "inline"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.remitAddress2}
              isInvalid={Boolean(touched.remitAddress2 && errors.remitAddress2)}
            />
            <Form.Control
              name="remitCity"
              placeholder="City"
              style={{ marginTop: "30px", width: "48%", display: "inline", marginRight: "4%"}}
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.remitCity}
              isInvalid={Boolean(touched.remitCity && errors.remitCity)}
            />
            <Form.Select
              name="remitState"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.remitState} 
              isInvalid={Boolean(touched.remitState && errors.remitState)}
              style={{marginTop: "30px", width: "20%", marginRight: "4%", display: "inline"}}>
                {usStateOptionList}
            </Form.Select>
            <InputMask
              style={{marginTop: "30px", width: "24%", display: "inline"}}
              type="tel"
              mask='99999'
              placeholder="Zip"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.remitZip}>
              {(inputProps) => <Form.Control
                name="remitZip"
                {...inputProps} 
                isInvalid={Boolean(touched.remitZip && errors.remitZip)}
              />}
            </InputMask>
            {(!!touched.remitAddress1 || !!touched.remitAddress2 || !!touched.remitCity || !!touched.remitState || !!touched.remitZip) && (
              <Form.Control.Feedback type="invalid">
                {errors.remitAddress1 || errors.remitAddress2 || errors.remitCity || errors.remitState || errors.remitZip}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Office Hours*</Form.Label>
            <Form.Control
              name="officeHours"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.officeHours}
              isInvalid={Boolean(touched.officeHours && errors.officeHours)}
            />
            {!!touched.officeHours && (
              <Form.Control.Feedback type="invalid">
                {errors.officeHours}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Group Medicare ID</Form.Label>
            <Form.Control
              name="groupMedicare"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.groupMedicare}
              isInvalid={Boolean(touched.groupMedicare && errors.groupMedicare)}
            />
            {!!touched.groupMedicare && (
              <Form.Control.Feedback type="invalid">
                {errors.groupMedicare}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Group Medicaid ID</Form.Label>
            <Form.Control
              name="groupMedicaid"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.groupMedicaid}
              isInvalid={Boolean(touched.groupMedicaid && errors.groupMedicaid)}
            />
            {!!touched.groupMedicaid && (
              <Form.Control.Feedback type="invalid">
                {errors.groupMedicaid}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <div id="submitButton" className="text-center mt-3">
            <br />
            {isSubmitting ?
            <Spinner size = "sm" animation="border" />
            :
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}
              >
                Save and Continue
              </Button>
              }
          </div>
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before moving forward</span></div>
          }
        </Form>
        
      )}
    </Formik>
  );
}

export default PracticeOnboardingDemographics;
